import type * as React from 'react';
import { slot, Tab, useTabListContext_unstable } from '@fluentui/react-components';
import type { GroundingCommandBarTabProps, GroundingCommandBarTabState, TabSlot } from './GroundingCommandBarTab.types';
import { useGroundingCommandBarTabValue } from '../../utils';

// If you add JSX to this file, be sure to change the file type to .tsx

/**
 * Create the state required to render GroundingCommandBarTab.
 *
 * The returned state can be modified with hooks such as useGroundingCommandBarTabStyles_unstable,
 * before being passed to renderGroundingCommandBarTab_unstable.
 *
 * @param props - props from this instance of GroundingCommandBarTab
 * @param ref - reference to root HTMLElement of GroundingCommandBarTab
 */
export const useGroundingCommandBarTab_unstable = (
  props: GroundingCommandBarTabProps,
  ref: React.Ref<HTMLButtonElement>,
): GroundingCommandBarTabState => {
  const { className, style, value: userValue, ...primary } = props;
  const value = useGroundingCommandBarTabValue(userValue);

  const selected = useTabListContext_unstable(ctx => ctx.selectedValue === value);

  return {
    components: {
      root: 'span',
      tab: Tab as TabSlot,
    },
    root: slot.always(props.root, { defaultProps: { className, style }, elementType: 'span' }),
    tab: slot.always(props.tab, {
      defaultProps: { ...primary, ref, value },
      elementType: Tab as TabSlot,
    }),
    value,
    selected,
  };
};
